import { Component, ElementRef, Input, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { TranslateService } from '@ngx-translate/core';
import { AngularMultiSelect } from "angular2-multiselect-dropdown/angular2-multiselect-dropdown";
import { PaginationInstance } from 'ngx-pagination';
import { Modal } from "../../../../../node_modules/ngx-modal";
import { AuthorizationPipe } from "../../../common/pipes/authorization.pipe";
import { NotificationType } from "../../enums/notification-types.enum";
import { DepartmentService } from "../../services/department.service";
import { CommonService } from "./../../../shared/services/common.service";
import { SelectizeOption } from "./../../interface/selectize-lookup";
import { User } from "./../../models/user";

@Component({
  selector: "department-assign-user",
  templateUrl: "../../templates/template1/views/department/department-assign-user.component.html",
  styleUrls: ["../../templates/template1/themes/default/css/department.less"],
  providers: [AuthorizationPipe]
})
export class AssignDepartmentUserComponent implements OnInit {
  @Input() departmentId: Number;
  @Input() operatingCountryId:number;
  @ViewChild('assignedUserLoginId') assignedUserLoginId: ElementRef;
  userAssignForm: FormGroup;
  unassignedUsers: User[];
  usersDropdownOptions: SelectizeOption;
  message: string = '';
  showSuccess: boolean = false;
  showFailure: boolean = false;
  rowStateValue: number;
  selectedUser:any;
  isUserSelected:boolean = false;
  isDesc:boolean = true;
  sortOrder:string="";
  pageCount:number;
  pageSize:number = 10;
  pageNumber:number = 1;
  sortColumn: any;
  UnAssignedUsersForm:FormGroup;
  isUserRequired:boolean=false;
  isRolesSelected:boolean=false;
  roles: any[];
  roleOnSelectAll: boolean = true;
  roleIds:any[];
  existedRols :any[];
  isSelected:boolean=true;
  @ViewChild('dropdownElem') dropdownElem: AngularMultiSelect;

   public dropdownSettings: any = {
        rolesDropdown: [],
        roleSelectedItems: [],
        roleIndex: 1,        
        settings: {}, 
    };

   /**
     * Pagination instance - to avoid console warnings - inorder to assign id for pagination
     */
    public paginationInstance: PaginationInstance = {
        id: 'assignedUsers-pagination',
        itemsPerPage: 10,
        currentPage: 1
    };

  @ViewChild('selectUsersAndAssign') createSelectUserPopup: Modal;
  constructor(
    private _formBulider: FormBuilder,
    private _translatePipe: TranslateService,
    private _commonService: CommonService,
    private _departmentService: DepartmentService,
  ) {
  }

  ngOnInit() {
      this.setFocusToTextBox();
      this.buildunAssignedUserForm();     
      this.getUnAssignedUsersByDepartment(this.UnAssignedUsersForm);    
       this.dropdownSettings.settings = {
            singleSelection: false,
            text: "Select Role",
            selectAllText: 'Select All',
            unSelectAllText: 'Select All',
            enableSearchFilter: false,
            classes: "myclass custom-class",
            badgeShowLimit: 1
        }; 
        this.bindDepartmentLevelRoles();     
  } 

  setFocusToTextBox(){
    
    setTimeout(function(){ 
      const assignedUserLoginId = document.getElementById("assignedUserLoginId");
      if (assignedUserLoginId) {
        assignedUserLoginId.focus();
      }
     }, 200);
  }

  initializeAssignUserForm() {
    this.userAssignForm = this._formBulider.group(
      {
        unassignedUserId: ["", Validators.required],
        description: [""],
        roleIds: ["", Validators.required],
      });
    this.bindDepartmentLevelRoles();
  }
 
  buildunAssignedUserForm(){
    const assignedUserLoginId = document.getElementById("assignedUserLoginId");
    if (assignedUserLoginId) {
      assignedUserLoginId.focus();
    }
       this.UnAssignedUsersForm = this._formBulider.group(
      {
        firstName: [""],
        lastName: [""],
        email: [""],
        phoneNumber: [""],
        loginID:[""]
      });
  }  

  closeDeleteMessage(): void {
    this.rowStateValue = null;
  }

  clearData(): void {
      this.setFocusToTextBox();
      this.userAssignForm.patchValue({
        unassignedUserId: [""],
        description: [""],
        roleIds: [""],
      });
  }  

  bindDepartmentLevelRoles() {
    this.roleIds =[];
    this.existedRols =[];
    this.dropdownSettings.rolesDropdown =[];
    this._departmentService.getRoles().subscribe((response: any) => {   
       if (response) {
          this.roles = response;     
           this.roles.forEach(item => {
            this.dropdownSettings.rolesDropdown.push({ id: item.id, itemName: item.name });
          }); 
          this.dropdownSettings.roleSelectedItems= JSON.parse(JSON.stringify(this.dropdownSettings.rolesDropdown));
          this.dropdownSettings.rolesDropdown.forEach(item => {
            this.existedRols.push(item.id);
            }); 
            this.roleIds =  this.existedRols;
      }
    });
  }

   openDropDown(element:string) {
        var elem = document.getElementById(element)
        var dropDownList = elem.children[0].children[1];
        dropDownList.removeAttribute("hidden");
    }
    onDropDowneBlur(element:string) {
        var elem = document.getElementById(element);
        var dropDownList = elem.children[0].children[1];
        dropDownList.setAttribute("hidden", "true");
    }

    close(evt: any) {
      this.dropdownElem.closeDropdown();
    }

    onItemSelect(item: any, indexValue: any) {
       this.roleIds =[];        
       if (this.dropdownSettings.roleIndex === +indexValue) {
            this.roleOnSelectAll = false;
             this.isSelected=false;  
             if(this.roles.length === this.dropdownSettings.roleSelectedItems.length){
                     this.roleOnSelectAll=true; 
             }
            this.isRolesSelected = this.dropdownSettings.roleSelectedItems.length>0?false:true;
            this.dropdownSettings.roleSelectedItems.forEach(item => {
                this.roleIds.push(item.id);
             }); 
        }       
    }

  
   onItemDeSelect(item: any, indexValue: any) {
     this.roleIds =[];
      if (this.dropdownSettings.roleIndex === +indexValue) {
          this.roleOnSelectAll = false;
          this.isSelected=false;    
      }     
      this.dropdownSettings.roleSelectedItems.forEach(item => {
           this.roleIds.push(item.id);
      }); 
       this.isRolesSelected = this.dropdownSettings.roleSelectedItems.length>0?false:true;
    }

     onSelectAll(items: any, indexValue: any) {
        this.roleIds =[];
        this.isSelected=false;   
        if (this.dropdownSettings.roleIndex === +indexValue) {
            this.roleOnSelectAll = true;            
        }    
         this.dropdownSettings.roleSelectedItems.forEach(item => {
                this.roleIds.push(item.id);
          }); 
        this.isRolesSelected = this.dropdownSettings.roleSelectedItems.length>0?false:true;       
    }

    onDeSelectAll(items: any, indexValue: any) { 
       this.roleIds =[];
       this.isSelected=false;        
        if (this.dropdownSettings.roleIndex === +indexValue) {
            this.roleOnSelectAll = false;          
        }       
    }  

  bindUnassignedUsersToDepartment(departmentId: any) {    
    this._departmentService.getUnassignedUsersToDepartment(departmentId).subscribe(response => {
       this.unassignedUsers = response;
       this.usersDropdownOptions = response;
    });
  }

  assignUserSubmit() {   
    let selectedRoles:any=[];
    selectedRoles = this.roleIds;   

   if(this.isSelected === true && this.roleIds.length===0) 
     {
          selectedRoles =[];
          selectedRoles = this.existedRols;
          this.roleIds = this.existedRols; 
     }
    if(selectedRoles.length ===0){
     
      this.isRolesSelected = true;
    }
    if(this.isRolesSelected==false){
    let userInfo = { id: this.selectedUser.userId, departmentId: this.departmentId,operatingCountryId:this.operatingCountryId, roleModelIds: this.roleIds.length === 0 ? [] : this.roleIds };
    this._departmentService.assignUser(userInfo).subscribe(response => {
      if (response.isSuccess) {      
        let success: any = this._translatePipe.get("User has been added successfully");
        this.message = response.validations != null && response.validations.length > 0 ? response.validations[0].message : '';
        this._commonService.createNotification("", success.value, NotificationType.SUCCESS);
        this.selectedUser =[];
        this.roleIds =[];
        this.pageNumber = 1;
        this.pageSize = 10;
        this.isUserSelected = false;
        this.isSelected = true;
        this.getUnAssignedUsersByDepartment(this.UnAssignedUsersForm); 
        this.createSelectUserPopup.close();   
      }
      else {
        let failed: any = this._translatePipe.get("validation-message.Your attempt to assign/update user is failed");
        this.message = "Your attempt to assign/update user is failed.";
        this._commonService.createNotification("", failed.value, NotificationType.ERROR);
      }
    }, error => {
      let unknown: any = this._translatePipe.get("validation-message.Unknown Error");
      this.message = (error != null && error[0] != null) ? error[0].field + " : " + error[0].message : unknown.value;
      this._commonService.createNotification("", this.message, NotificationType.ERROR);
    }); 
  } 
  }

  createSuccessClose() {
    this.showSuccess = false;
    this.showFailure = false;
  }

  resetFormData() {
    this.createSuccessClose();
  } 

  clearFields(){ 
     this.resetData();    
     this.buildunAssignedUserForm();
     this.getUnAssignedUsersByDepartment(this.UnAssignedUsersForm);
     const assignedUserLoginId = document.getElementById("assignedUserLoginId");  
    if (assignedUserLoginId) {
      assignedUserLoginId.focus();
    }
  }

  resetData(){
     this.pageNumber = 1;
     this.pageSize = 10;
     this.isDesc = true;
     this.selectedUser =[];    
     this.sortColumn =""; 
     this.isUserRequired = false;
     this.isRolesSelected = false;
     this.isUserSelected = false;
     this.roleIds =[];
  }

  selectUser(user:any){
       if(user!==undefined){
      this.isUserSelected = true;
      this.selectedUser = user;
      this.bindDepartmentLevelRoles();
      this.createSelectUserPopup.open();
     
    }
    else{    
      this.isUserSelected = false;
    }
  }

   onSearch(UnAssignedUsersForm: any,valid?:any) {
    
    window.document.getElementById("search-button").classList.add('button-active');
    setTimeout(() => {
        window.document.getElementById("search-button").classList.remove('button-active');
    }, 1000); 
     this.pageNumber = 1;
     this.pageSize = 10;
     this.isDesc = true;
     this.getUnAssignedUsersByDepartment(this.UnAssignedUsersForm);      
   }

    getUnAssignedUsersByDepartment(userSearchForm: any) {
        this._departmentService.getUnAssignedUsersByDeaprtmentd(this.departmentId, userSearchForm.value.firstName, userSearchForm.value.lastName,
            userSearchForm.value.email, userSearchForm.value.phoneNumber, userSearchForm.value.loginID,this.pageSize, this.pageNumber, !this.isDesc, this.sortColumn).subscribe((response:any) => {
                if (response != null) {
                    this.pageCount = response["totalCount"];                  
                    this.unassignedUsers = response["content"];
                    this.unassignedUsers = this.unassignedUsers.filter(item => item.userName !== "" && item.userName !== undefined && item.userName !==null );
                } else {
                    this.pageCount = 0;
                    this.unassignedUsers = [];
                }
            }, (error:any) =>
                this.message = <any>error
          );
    }

    clearFormData(){     
      this.createSelectUserPopup.close();
      this.resetData();
      this.isSelected = true;       
  }

  onLoginIDFocus(UnAssignedUsersForm: any) {
    const assignedUserLoginId = document.getElementById("assignedUserLoginId");
    if (assignedUserLoginId) {
      assignedUserLoginId.focus();
    }
    this.onSearch(UnAssignedUsersForm);
  }
    rolesChanged(event:any){
       this.isRolesSelected = false;
    }

     /**
     * sort table by respective column
     * @param sortColumn 
     */

    sortTableByColumn(sortColumn:string){      
        this.isDesc = (this.sortColumn == sortColumn) ? !this.isDesc : this.isDesc;
        this.sortOrder = this.isDesc ? "DESC" : "ASC";
        this.sortColumn = sortColumn;        
         //added this condition not to hit service if there are no items in grid.
        if (this.unassignedUsers.length === 0) {
                    return;
        }
        this.getUnAssignedUsersByDepartment(this.UnAssignedUsersForm);
   }
      
     /**
       * On Page change 
       * @param pageNumber 
       */
    pageChange(pageNumber: number) {
      
        if (!isNaN(pageNumber)) {
            this.pageNumber = pageNumber;
          this.pageSize = 10;
          this.UnAssignedUsersForm.value.pageNumber = this.pageNumber;
          this.UnAssignedUsersForm.value.pageSize = this.pageSize;
          this.getUnAssignedUsersByDepartment(this.UnAssignedUsersForm);
       }
    }

  
  closePopUp()
  {
  this.createSelectUserPopup.close();
  }

}


// WEBPACK FOOTER //
// ./src/app/customerservice/components/department/department-assign-user.component.ts